import * as yup from "yup";

export const VOID_MANAGEMENT_VALIDATION_SCHEMA = yup.object().shape({
  raNumber : yup.string().required("common.error.required"),
  dmsIdentificationCode:  yup.object().shape({ 
    code: yup.string().required("common.error.required"),
    description: yup.string().required("common.error.required")
  }),
  pickUpDate: yup.date().nullable(),
  renewalsAndSubstitutions: yup.string().required("common.error.required"),
  reasons: yup.string().required("common.error.required")
});